import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MonacoEditor from '@/views/visual/dataScreen/components/editor';
import layer from '@/views/visual/dataScreen/group/layer';
import top from '@/views/visual/dataScreen/group/top';
import headers from '@/views/visual/dataScreen/group/header';
import imglist from '@/views/visual/dataScreen/group/imglist';
import contentmenu from '@/views/visual/dataScreen/group/contentmenu';
import codeedit from '@/views/visual/dataScreen/group/code';
import { dicOption } from '@/views/visual/dataScreen/js/option/config';
import init from '@/views/visual/dataScreen/mixins/';
import { createFile } from '@/views/visual/dataScreen/js/utils/utils';
import components from '@/views/visual/dataScreen/js/option/components';
import SketchRule from "vue-sketch-ruler";
import { getList } from "@/api/visual/db";
import '@/assets/avue-preview.css';
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
import Vue from 'vue';
import dataV from '@jiaminghi/data-view';
Vue.use(dataV);
Vue.use(Avue, {
  size: 'mini'
});
export default {
  mixins: [init, components],
  beforeCreate: function beforeCreate() {
    window.$website = {
      url: window.domainURL,
      isDemo: false,
      isDemoTip: '演示环境不允许操作'
    };
    Vue.prototype.$website = window.$website;
  },
  data: function data() {
    return {
      menuShow: true,
      paramsShow: true,
      show: false,
      keys: {
        ctrl: false
      },
      dataRes: '',
      db: '',
      sql: '',
      nav: [],
      DIC: {
        sql: []
      },
      loading: '',
      childProps: {
        label: 'name',
        value: 'index'
      },
      key: '',
      menuFlag: true,
      code: {
        box: false,
        type: '',
        obj: ''
      },
      form: {},
      dicOption: dicOption,
      tabsActive: 0,
      // 标尺
      scale: 0.9,
      //初始化标尺的缩放
      startX: 0,
      //x轴标尺开始的坐标数值
      startY: 0,
      lines: {
        //初始化水平标尺上的参考线
        h: [],
        v: []
      },
      rendIndex: 0,
      //重新渲染组件
      shadow: {
        x: 0,
        y: 0
      },
      // 阴影大小
      thick: 20,
      //标尺的厚度
      width: 0,
      // 标尺宽,后面会初始化
      height: 0,
      // 标尺高,后面会初始化
      isShowReferLine: true,
      // 显示参考线
      isImgOpen: true,
      //眼镜打开
      imgOpenData: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbCAYAAAAOEM1uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAQNSURBVHja7JdvSON1HMdfP126/shSmaZ1ntuZbTLihOnSdJlPhIquB0VR1DZM9En0wCB3qCXKVOh86mmakdGDOqyHityBidYN1HPYZqbhOZprMGTOUk/9/XryWyxvek5NIu4Lg/H+fPj8Xt/P98/n8xUkSeK/PIT7gP8GoCAI8cTQAoWAHkgFRCAA3AKmgeBRA8VkOSZgMvAy8DZQCqQf4OcFRoDPgYmzAnwdaAAuxpFlCbgGfAR4ThUwYhcE4QngExnw71FWVuax2WwBk8mkSE9PV+7t7Ymrq6vbw8PD0uDgYO7CwsK5KPc14ENJkj497FtxAwqCYAK+kvcbANXV1U6Hw6HIyMh4GlAckJHwzMzMrM1my3a5XNoo01XgPUmSdk8MCLwEfAmoAPLz872jo6OrOTk5xVGBQ0tLS575+fnt7OzsRIPBcD4pKelctL2/v3+mtrbWLIpigixfA94BNk8C+JoMlyRn7WZvb68mISEhI+IQCASmKyoq0jweT25EU6lU4aGhoZnKykpzdNzl5eWbRqPxyWAwmCZL3wJvAHeOA/iCPMsHARwOx7jdbi+JXs7t7e3lrKys1LW1NVWsJXa73ZN6vb40WltfX3cbDIZ0r9ebKUv9wLvxAhYC1+V7je7u7rG6urrn9vu1tbWNNzU1lR90KgsLC5emp6cfB5TRejgc9mg0msyoTNYDXfEAjgFmQGxpaZlobm6OBbFrMpl+dTqd+YdcLztbW1ve5ORk7X6D3++f0ul0+aFQKAXYAF6RJOn6UQGDQBrgE0VRJQjCw7EAjUbj8tTUVN4hgLubm5u3lUrlhVjG+vr6ya6ursgWaJck6fJRAW8AzwNia2vrRGNjY8xltNvtEx0dHc8eRKfX62+73W418NB+m8/nm9LpdE+Fw+FHgD+AS/Fk8CJwI7IHe3t7x2pqau7agxsbG/NqtTp3a2tLGQtwcnJyvKSk5K7JhcPhnzQaTXYwGEyVpQ+AK8c5xd9EZt/e3v59Q0ND6f5LeXFx8cfy8vILfr9fHdEUCsVOX1/fhMViqdgfOxQKzRUUFKh9Pt+JTnHk76vyPZgcqR49PT3nExMTM/+x0XZ3fePj47/Mzc2RlZVFVVVVRkpKin5/3JWVFWdRUVFeIBCInN7v5NJ55ySV5EUZ8lEArVb728jIiDcvL++ZONqo0MDAwK2ampoyURQTZXlI7ob+PI1aXAR8AegiutVqdXZ2dt6zFs/OzrosFstjLpcr+iR3A+9LkrRzKs2CrGUCV4C3on3NZrPHarX+Xlxc/MARu5nLkiRdPbVuJsa4BDQCxjj6QRH4GvgY+PksOmqF3FG/KVcc9T066s+AH86y5Y8eOXI282XQyJtkRv6d/pvk/rPz/wT41wBibRrpeMs+PAAAAABJRU5ErkJggg==',
      // 左上角图片
      imgClose: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAPYSURBVHja7JVPTFRXFIe/+96gGRHEhQzBFMJKSKSkLTgtGxemSXcktohW2RBmTAjUClIYZ6Cxi+fQDgOCLJgJhqTSBAtLdjaxaSqQWnDSNp2U0I6FFh0SDdV0oMx7pwuZCUXjnyZNuvBsbnLvufe7555zfleJCP+1qReQfwVRSqWmqoFDIE3A+iZXQDbGlMmmNTatP5xPn/0ohOOgLgNtIB8DOlAKvAzsBTKBP4FF4Dvge1DrzwsBaAAuAJ8CxbpuezU/P397QcFLZGVlcf/+fRYXF1lc/G3VNJM/AJ8Dw8CdZ4QoQI4AIWBXaWkpQ0ND5v79+zW73Z5+n9XVVWZnb8rExIQ2MnKZWCz2M/Dhw1d4eiTngXafz2dmZ2ebPp9P6+vrl5qaI2p8fFyi0aheUlJiHj78tpaTs0sHJB6PW4HAJ3og0I2I+AHPkyAeu91uDA4OmrW1tRpAT09vsr29XXM4ciWZTJKXl2ctLCyoHTsy1ZUro+J0OjNSWR8ZGbFcLpeeSCTOAucfBykDpvr7+7c3NjamS+bevXvJ4uIS4vE7tra2tjW/32+7ffu21Ne7rJmZb7VIJKL27Nmjp0ADAwM0NjauAW+IyM2tkAGn8/WG69e/NjVNS20iHA6vd3Z2qrq6OtMwDFswGLROnz6dcffu3WRRUZEVCARwuVzbUv6WZVmVlZXa9PT0RRFp2gq56na7Dw0ODv6jGc6cOWNdu/Zl8saNb/RgMGi1tLSo7u5uaW5u1srLK8yDBw/aursD2ubmcbtPqnA4dFVE3twKuVBeXv7e5OSkabPZ0pGEQuG/WltbicV+0Xbv3m0LBnvWW1qatbNnvclLl4b0c+c+ErfblcoLa2trptPp1CORSEBEWrdCSoBpwzB2ejyedE6Wl5fNsrIyqaiokFAopBwOh/J4PKbf79/mcDiS0WiUnJwcWyoKr9erDMNYBg6ISOxx1dWg6/pAb2+vtZF8DWBqanr96NEalUgkpKCgQJaWljRN04jH43R1dcmpU6dsgBiGobxer3qoGnz2pD5pBfx1dXWaz+czi4qKNECtrKyYY2NjVjQa1fftK7aqq99hdHRUmpqaVEdHhzU/P58xPDycAN4Hws8iK28B/tzc3LJjx96lqqrKOnCggszMzLRmPHjwQM3MzFj19fX63NwcwDJQBUymK+ApEEDtBDkOnFBKvZafv9deWFhIdnYWKysr3Lr1K0tLvydE5CvgJ1AnQZqBi88DSV1aA0qAV4CCDRX+A1gAZoEfN/w/ALqAEyAjzwvZ8mc8KukblgGqD/gCZOyxkBd//P8G8vcAMK383pmr7aEAAAAASUVORK5CYII=',
      dragSlide: false // 拖动滚动条标记

    };
  },
  components: {
    MonacoEditor: MonacoEditor,
    imglist: imglist,
    layer: layer,
    codeedit: codeedit,
    top: top,
    headers: headers,
    contentmenu: contentmenu,
    SketchRule: SketchRule
  },
  computed: {
    isKeysCtrl: function isKeysCtrl() {
      return this.keys.ctrl == true;
    },
    isStatic: function isStatic() {
      return this.activeObj.dataType == 0;
    },
    isApi: function isApi() {
      return this.activeObj.dataType == 1;
    },
    isSql: function isSql() {
      return this.activeObj.dataType == 2;
    },
    isFolder: function isFolder() {
      return this.activeObj.children;
    },
    isActive: function isActive() {
      return this.active.length !== 0;
    },
    isSelectActive: function isSelectActive() {
      return this.active.length > 1;
    },
    childList: function childList() {
      return this.list.filter(function (ele) {
        if (['tabs'].includes(ele.component.prop)) {
          return false;
        }

        return true;
      });
    },
    activeComponent: function activeComponent() {
      return this.activeObj.component || {};
    },
    activeOption: function activeOption() {
      return this.activeObj.option || {};
    },
    activeObj: function activeObj() {
      if (this.validatenull(this.activeIndex)) return {};
      var item = this.findlist(this.activeIndex);
      if (!item.child) item.child = {};
      return item;
    },
    activeList: function activeList() {
      var _this = this;

      var result = [];
      this.active.forEach(function (ele) {
        var item = _this.findnav(ele, true);

        result.push(item.obj);
      });
      return result;
    },

    /* 标尺用的 */
    palette: function palette() {
      return {
        bgColor: '#181b24',
        // ruler bg color
        longfgColor: '#BABBBC',
        // ruler longer mark color
        shortfgColor: '#9C9C9C',
        // ruler shorter mark color
        fontColor: '#fff',
        // ruler font color
        shadowColor: '#181b24',
        // ruler shadow color
        lineColor: '#EB5648',
        borderColor: '#B5B5B5',
        cornerActiveColor: '#fff'
      };
    },
    // 画布大小,一定要是computer里面,否则缩放页面会失效
    canvasStyle: function canvasStyle() {
      return {
        width: window.innerWidth - 530 + 'px',
        transform: "scale(".concat(this.scale, ")")
      };
    }
  },
  watch: {
    activeObj: {
      handler: function handler(val) {
        if (this.activeObj.sql && this.isSql) {
          var mode = JSON.parse(this.activeObj.sql);
          this.db = mode.id;
          this.sql = mode.sql;
        } else {
          this.db = '';
          this.sql = '';
        }
      },
      deep: true
    },
    menuFlag: function menuFlag() {
      this.setResize();
    },
    overactive: function overactive(n, o) {
      var _this2 = this;

      [o, n].forEach(function (ele, index) {
        if (!ele) return;

        _this2.setActive(ele, index === 1, 'setOverActive');
      });
    },
    active: function active(n, o) {
      var _this3 = this;

      [o, n].forEach(function (ele, index) {
        ele.forEach(function (item) {
          _this3.setActive(item, index === 1, 'setActive');
        });
      }); //隐藏右键菜单

      this.$refs.contentmenu.hide(); // 初始化选项卡

      this.tabsActive = '0';
    }
  },
  created: function created() {
    this.listen();
    this.iniresize();
    this.initSqlList();
  },
  mounted: function mounted() {
    var _this4 = this;

    this.initFun();
    this.$nextTick(function () {
      _this4.initSize();
    });
  },
  methods: {
    handleImport: function handleImport(file, fileLis) {
      var _this5 = this;

      this.$Export.xlsx(file.raw).then(function (data) {
        _this5.activeObj.data = data.results;

        _this5.$message.success('导入成功');

        _this5.handleRes();
      });
    },
    handleRefresh: function handleRefresh() {
      return this.$refs.container.handleRefresh();
    },
    handleRes: function handleRes() {
      var _this6 = this;

      if (this.isSql) {
        this.$set(this.activeObj, 'sql', JSON.stringify({
          id: this.db,
          sql: this.sql
        }));
      }

      this.handleRefresh().then(function (res) {
        if (!_this6.validatenull(res)) {
          _this6.dataRes = JSON.stringify(res || {}, null, 4);
        } else {
          _this6.dataRes = '';
        }

        _this6.$message.success('数据刷新成功');
      });
    },
    handleSql: function handleSql() {
      var _this7 = this;

      this.show = true;
      this.dataRes = '';
      this.$nextTick(function () {
        var result = false;

        if (_this7.isSql && !_this7.validatenull(_this7.sql)) {
          result = true;
        } else if (_this7.isApi && !_this7.validatenull(_this7.activeObj.url)) {
          result = true;
        } else {
          result = true;
        }

        if (result) _this7.handleRes();
      });
    },
    initSqlList: function initSqlList() {
      var _this8 = this;

      getList(1, 100).then(function (res) {
        var data = res.result;
        _this8.DIC.sql = data.records.map(function (ele) {
          return {
            label: ele.name,
            value: ele.id
          };
        });
      });
    },
    codeClose: function codeClose(value) {
      if (this.configData.includes(this.code.type)) {
        this.config[this.code.type] = value;
      } else {
        this.activeObj[this.code.type] = value;
      }
    },
    openCode: function openCode(type) {
      this.code.type = type;

      if (this.configData.includes(type)) {
        this.code.obj = this.config[type];
      } else {
        this.code.obj = this.activeObj[type];
      }

      this.code.box = true;
    },
    initFun: function initFun() {
      var _this9 = this;

      ['setScale', 'setResize'].forEach(function (ele) {
        _this9[ele] = _this9.$refs.container[ele];
      });
      ['handleAdd'].forEach(function (ele) {
        _this9[ele] = _this9.$refs.top[ele];
      });
    },
    // 右键菜单
    handleContextMenu: function handleContextMenu(e) {
      var _this10 = this;

      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!item.index || this.isKeysCtrl) return;else if (!this.isSelectActive) {
        this.active = [item.index];
        this.activeIndex = item.index;
      }
      this.$nextTick(function () {
        return _this10.$refs.contentmenu.show(e.clientX, e.clientY);
      });
    },
    //监听键盘的按键
    listen: function listen() {
      var _this11 = this;

      document.onkeydown = function (e) {
        _this11.keys.ctrl = e.keyCode === 17;
        if (e.target.nodeName == 'TEXTAREA' || e.target.nodeName == 'INPUT') return; // 按下空格键

        if (e.keyCode == 32) {
          e.preventDefault();
          _this11.keys.space = true;
        }
      };

      document.onkeyup = function () {
        _this11.keys.ctrl = false;
      };
    },
    setActive: function setActive(val, result, fun) {
      var obj = this.$refs.container.getDragObj(val);
      if (!this.validatenull(obj)) obj[0][fun](result);
    },
    //批量成组
    handleFloder: function handleFloder() {
      var _this12 = this;

      var floder = createFile();
      this.active.forEach(function (index) {
        var params = _this12.findnav(index);

        floder.children.push(params.obj);
        params.parent.splice(params.count, 1);
      });
      this.nav.push(floder);
      this.handleInitActive();
    },
    //批量删除
    handleDeleteSelect: function handleDeleteSelect() {
      var _this13 = this;

      this.$confirm("\u662F\u5426\u6279\u91CF\u5220\u9664\u6240\u9009\u56FE\u5C42?", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this13.active.forEach(function (index) {
          var params = _this13.findnav(index);

          params.parent.splice(params.count, 1);
        });

        _this13.handleInitActive();
      });
    },
    vaildProp: function vaildProp(name, list) {
      if (list) return list.includes(this.activeComponent.prop) || this.active.length > 1;
      return this.dicOption[name].includes(this.activeComponent.prop);
    },
    formatTooltip: function formatTooltip(val) {
      return parseInt(val);
    },
    //打开图库
    handleOpenImg: function handleOpenImg(item, type) {
      this.$refs.imglist.openImg(item, type);
    },
    //图库框回调赋值
    handleSetimg: function handleSetimg(val, type) {
      var params = type.split('.')[1];

      if (type.includes('config')) {
        this.config[params] = val;
      } else if (type.includes('activeObj.data.value')) {
        this.activeObj.data.value = val;
      } else if (type.includes('activeObj.data')) {
        this.activeObj.data = val;
      } else if (type.includes('activeObj')) {
        this.activeObj[params] = val;
      } else if (type.includes('activeOption')) {
        this.activeOption[params] = val;
      }
    },

    /* **************************标尺方法开始******************************* */
    // 滚轮触发
    handleScroll: function handleScroll() {
      var screensRect = this.$refs.screensRef.getBoundingClientRect();
      var canvasRect = this.$refs.canvas.getBoundingClientRect(); // 标尺开始的刻度

      var startX = (screensRect.left + this.thick - canvasRect.left) / this.scale;
      var startY = (screensRect.top + this.thick - canvasRect.top) / this.scale;
      this.startX = startX >> 0;
      this.startY = startY >> 0;
    },
    // 控制缩放值
    handleWheel: function handleWheel(e) {
      var _this14 = this;

      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
        var nextScale = parseFloat(Math.max(0.2, this.scale - e.deltaY / 500).toFixed(2));
        this.scale = nextScale;
      }

      this.$nextTick(function () {
        _this14.handleScroll();
      });
    },
    // 初始化标尺数值
    initSize: function initSize() {
      var domW = this.$refs.section;
      var width = window.innerWidth - 530;
      var height = window.innerHeight - 45;
      domW.style.width = width + 'px';
      domW.style.height = height + 'px';
      this.width = width - this.thick;
      this.height = height - this.thick; // 画布阴影部分

      this.shadow = {
        x: 0,
        y: 0,
        width: width,
        height: height
      }; // 滚动居中

      var dom = this.$refs.containerRef.getBoundingClientRect();
      this.$refs.screensRef.scrollLeft = dom.width / 2 - this.thick;
      this.$refs.screensRef.scrollTop = dom.height / 2 - this.thick;
    },
    // resize
    iniresize: function iniresize() {
      var _this15 = this;

      window.addEventListener('resize', function () {
        var width = _this15.width;
        var height = _this15.height;

        _this15.initSize();

        var rate = Math.min(_this15.width / width, _this15.height / height);
        _this15.scale = rate > 1 ? rate * 0.5 : rate;
        _this15.rendIndex++;
      });
    },
    // 图片点击事件
    imgClick: function imgClick() {
      this.isShowReferLine = !this.isShowReferLine;
    },
    // 鼠标按下事件
    dragMousedown: function dragMousedown(e) {
      // 如果按下了空格键,且按下鼠标左键,那么鼠标变抓手,开启滚动条随鼠标拖动的操作
      this.handleInitActive();

      if (this.keys.space) {
        this.dragSlide = true;
        window.stardragEvent = e;
        window.startSlideX = this.$refs.screensRef.scrollLeft;
        window.startSlideY = this.$refs.screensRef.scrollTop;
      }
    },
    //鼠标抬起操作
    dragMouseup: function dragMouseup() {
      this.dragSlide = false;
    },
    // 鼠标移动骚操作
    dragMousemove: function dragMousemove(e) {
      if (this.dragSlide) {
        var x = e.clientX - window.stardragEvent.clientX;
        var y = e.clientY - window.stardragEvent.clientY;
        this.$refs.screensRef.scrollLeft = window.startSlideX - x;
        this.$refs.screensRef.scrollTop = window.startSlideY - y;
      }
    },
    selectNav: function selectNav(item) {
      if (Array.isArray(item)) {
        this.active = this.active.concat(item);
      } else if (this.isKeysCtrl) {
        this.active.push(item);
      } else if (!this.active.includes(item)) {
        this.active = [item];
        this.activeIndex = item;
      }
    }
  }
};